import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const UniversalLinks = lazy(() =>
  import("@scenes/UniversalLinks").then((module) => ({
    default: module.UniversalLinks,
  }))
);

export const universalLinksNRO: NavigationRoutingObject = {
  section: "settings",
  Component: UniversalLinks,
  heading: (t: I18nT<"dashboard-navigation">) => t("universal-links-nro-heading", "Universal Links"),
  pageNameForTracking: () => "Universal Links",
  tag: "new",
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  defaultRoute: "/company_settings/universal_links/:appGroupId",
  getDeveloperNavigationAllowed: ({ hasPermission, featureOn }) => {
    if (!featureOn("verified_domain")) {
      return false;
    }
    return (
      hasPermission("company", { permission: "viewDomainSettings" }) ||
      hasPermission("company", { permission: "editDomainSettings" })
    );
  },
  additionalSearchTerms: (t: I18nT<"dashboard-navigation">) => [
    {
      keywords: [
        t("universal-links-nro-additional-keyword-universal-links", "universal links"),
        t("universal-links-nro-additional-keyword-deep-links", "deep links"),
        t("universal-links-nro-additional-keyword-app-links", "app links"),
      ],
    },
  ],
  additionalSearchableFeatures: () => ({}),
};
